import { CreateReportPayload, ReportItem, ReportListResponse } from "entities/reports";
import { DELETE, GET, POST } from "utils/http";

const baseUrl = "/api/reports";

export const getList = (query: string) => GET<ReportListResponse>(`${baseUrl}${query}`);

export const create = (payload: CreateReportPayload) => POST<CreateReportPayload, ReportItem>(baseUrl, payload);

export const download = (id: number) => GET<Blob>(`${baseUrl}/${id}/download`, { responseType: "blob" });

export const remove = (id: number) => DELETE(`${baseUrl}/${id}`);

export const retry = (id: number) => POST<undefined, ReportItem>(`${baseUrl}/${id}/retry`, undefined);
